<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <v-row>
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title class="d-flex justify-center text-subtitle-2">
            Grados de configuración del sistema
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="d-flex">
                <v-checkbox v-model="selectAll" class="ma-0 pa-0" @change="selectAllCheckboxes" label="Seleccionar todos"
                  color="success" />
                <v-spacer />
                <ButtonComp text-button="Agregar" :disabled="!gradosSeleccionados.length" iconBut="fas fa-plus"
                  @click="aggGrados()" />
              </v-col>
              <v-col cols="12" class="d-flex justify-center" v-for="item of Grados" :key="item.id">
                <v-card :color="item.color" width="240" elevation="7">
                  <v-list-item dark three-line>
                    <v-list-item-content>
                      <span class="mb-1">
                        <h3>{{ item.desc_grado }}</h3>
                      </span>
                      <v-list-item-subtitle>{{
                        item.desc_nivel
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-card-actions class="white">
                    <v-spacer />
                    <v-checkbox class="ma-0 pa-0" v-model="gradosSeleccionados" :value="item.id" color="success"
                      :key="item.id" hide-details></v-checkbox>
                    <!-- <ButtonComp textButton="Agregar" iconBut="fas fa-plus" @click="aggGrados(item)"
                      v-if="componenteEvento.agregar_submodulo" /> -->
                  </v-card-actions>
                </v-card>
              </v-col>

              <v-col v-if="Grados.length < 1">
                <v-card outlined>
                  <v-card-text style="height: 240px" class="d-flex justify-center align-center">
                    No hay grados configurados en el sistema.
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

      </v-col>
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title class="d-flex justify-center text-subtitle-2">
            Grados del colegio
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col class="d-flex justify-center" cols="12" md="4" v-for="grado of GradosAdmin" :key="grado.id">
                <v-card :color="grado.color" width="240" dark elevation="7">
                  <v-list-item three-line>
                    <v-list-item-content>
                      <span class="mb-1">
                        <h3>{{ grado.desc_grado }}</h3>
                      </span>
                      <v-list-item-subtitle>{{
                        grado.desc_nivel
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-card-actions class="white">
                    <v-spacer />
                    <ButtonComp v-if="componenteEvento.borrar_submodulo" @click="deleteGrado(grado.id)" deleteButton
                      tooltipText="Eliminar nivel" />
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" v-if="mostrarMensaje">
                <v-card outlined>
                  <v-card-text style="height: 240px" class="d-flex justify-center align-center">
                    Aún no has seleccionado ningún grado para tu año lectivo activo.
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>


    <!-- modal agregar grado a mantenimiento --->
    <ComunDialogComp v-model="grado_dialog" Confirmdialog titleWindow="Confirmar" @close-modal="grado_dialog = false"
      @confirm-item="addgrados" @cancel-item="grado_dialog = false">
      <template v-slot:body>
        <h3>
          ¿Está seguro de agregar este "grado" a
          "colegio"?
        </h3>
        <ul>
          <li v-for="grado in dataGradosSeleccionadas" :key="grado.id">
            {{ grado.desc_grado }}
          </li>
        </ul>
        <!-- <v-chip :color="newGrados.color" class="white--text">
          {{ newGrados.desc_grado }} - {{ newGrados.desc_nivel }}
        </v-chip> -->
      </template>
    </ComunDialogComp>

    <!--------fin modal-->

    <!-- modal - delete -->
    <confirm @aceptar="deleted" @cancelar="cancelar" titleWindow="Eliminar grado" :title="confirm.title"
      :active="confirm.active" />
  </div>
</template>




<script>
import axios from "../../../../helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import ButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';
import ComunDialogComp from '../../../../components/ComponentsEst/ComunDialogComp.vue';

export default {
  components: {
    ComunDialogComp,
    ButtonComp
  },
  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 13, id_modulo: 6 },

    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////
    gradosSeleccionados: [],
    selectAll: false,

    confirm: {
      id: 0,
      title: "",
      active: false,
    },
    search: "",
    grado_dialog: false,
    Grados: [],
    GradosAdmin: [],
    mostrarMensaje: false,

    Estados: [
      { nombre: "Activo", valor: 1 },
      { nombre: "Inactivo", valor: 0 },
    ],

    newGrados: {
      id_grado: 0,
      estado_grado: 1,
      id_nivel: 0,
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
      id_colegio: sessionStorage.id_colegio,
      id_usuario: sessionStorage.id,
    },

    newDefaultGrados: {
      id_grado: 0,
      estado_grado: 1,
      id_nivel: 0,
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
      id_colegio: sessionStorage.id_colegio,
      id_usuario: sessionStorage.id,
    },

    editedIndex2: -1,

    headers2: [
      {
        text: "#",
        align: "left",
        sortable: false,
        value: "id",
        class: "secondary",
      },
      { text: "Nombre del Grado", value: "desc_grado", class: "secondary" },
      { text: "Nivel", value: "desc_nivel", class: "secondary" },
      { text: "Estado", value: "estado", sortable: false, class: "secondary" },
      {
        text: "Acciones",
        value: "action",
        sortable: false,
        class: "secondary",
      },
    ],
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),

    dataGradosSeleccionadas() {
      return this.Grados.filter(e => this.gradosSeleccionados.includes(e.id))
    }
  },

  created() {
    this.actualizarParamentro();

    this.getAllGradosAdmin();
    this.getAllGrados();
  },



  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    //-----------obtener Grados mantenimiento--------------

    selectAllCheckboxes() {
      if (this.selectAll) {
        // Si el checkbox "Seleccionar Todos" está marcado, seleccionar todos los niveles
        this.gradosSeleccionados = this.Grados.map((grado) => grado.id);
      } else {
        // Si el checkbox "Seleccionar Todos" está desmarcado, deseleccionar todos los niveles
        this.gradosSeleccionados = [];
      }
    },

    clear_confirm() {
      this.confirm.id = 0;
      this.confirm.title = "";
      this.confirm.active = false;
    },
    async getAllGrados() {
      let params = {
        id_colegio: sessionStorage.id_colegio,
        id_anio_lectivo: sessionStorage.id_ano_lectivo,
      };

      try {
        let response = await axios.post(
          "/administrativo/grado/mant/filt/",
          params
        );
        this.Grados = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    //----------------traer grados administrativo-------------
    async getAllGradosAdmin() {
      this.mostrarMensaje = false;
      let params = {
        id_colegio: sessionStorage.id_colegio,
        id_anio_lectivo: sessionStorage.id_ano_lectivo,
      };

      //console.log('X--getAllGradosAdmin----->'+JSON.stringify(params))
      try {
        let response = await axios.post(
          "/administrativo/grado/gradosadmin/",
          params
        );
        this.GradosAdmin = response.data;

        if (this.GradosAdmin.length === 0) {
          this.mostrarMensaje = true;
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    //---------agregar grados ----------
    aggGrados() {
      // this.newGrados.id_grado = item.id;
      // this.newGrados.id_nivel = item.id_nivel;
      // this.newGrados.desc_grado = item.desc_grado;
      // this.newGrados.desc_nivel = item.desc_nivel;
      // this.newGrados.color = item.color;
      this.grado_dialog = true;
    },

    //-----------agregar Grados-------------------------
    async addgrados() {
      // let params = this.newGrados;

      try {
        const areaBase = {
          id_usuario: sessionStorage.id,
          id_ano_lectivo: sessionStorage.id_ano_lectivo,
          id_colegio: sessionStorage.id_colegio,
        }
        const arrayPromesas = []
        this.dataGradosSeleccionadas.forEach(grado => {

          const params = {
            ...areaBase,
            id_nivel: grado.id_nivel,
            id_grado: grado.id
          }
          arrayPromesas.push(axios.post("/administrativo/grado", params))

        });
        // let resp = await axios.post("/administrativo/grado", params);
        await Promise.all(arrayPromesas)

        this.getAllGradosAdmin();
        this.getAllGrados();
        this.gradosSeleccionados.splice(0)
        this.grado_dialog = false;

        this.setEnviarMens({
          tipo: "S",
          mensaje: `¡Información creada con éxito!`,
          tiempo: null,
        });
        //console.log(response);
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    //-- METODO QUE PERMITE ELIMINAR UN GRADO
    //------------borrar Grado -------------
    async deleteGrado(id) {
      this.confirm.active = true;
      this.confirm.title = "¿Está seguro de eliminar este registro?";
      this.confirm.id = id;
      console.log("confimr:", this.confirm);
    },
    // confirm dialog event
    async deleted() {
      await axios.delete("/administrativo/grado/" + this.confirm.id).then((resp) => {
        if (resp.data.messageT == "S") {
          this.getAllGradosAdmin();
          this.getAllGrados();
          this.grado_dialog = false;
          this.clear_confirm()
        }
        this.setEnviarMens({
          tipo: resp.data.messageT,
          mensaje: resp.data.message,
          tiempo: null,
        });
      });
    },

    cancelar() {
      this.clear_confirm();
    },
  },
};
</script>

